module.exports = "<a class=\"clearfix\">\n  <span class=\"pull-left\">{{match.model.name}}</span>\n</a>\n";